module.exports = __webpack_public_path__ + "static/media/diving_1024.4902245f.webp";